import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Image from 'components/Image'
import Divider from 'components/Divider'
import { Modal } from 'components/Modal'
import Button from 'components/Button'

import { Label, StyledCard, StyledRow, StyledCardInfo, QRContainer } from './styled'
import { ReactComponent as QRCode } from './media/qr.svg'

const AppleModalPreview = ({ formData = {}, appData }) => {
	const { wideLogoImg, backgroundColor, labelColor, foregroundColor, accountIdLabel, rewardsTierLabel, rewardsTier, secondaryRewardsTierLabel, secondaryRewardsTier, homepageUri, linkPhoneUri } = formData
	const [showModal, setShowModal] = useState(false)
	const [t] = useTranslation()
	return(
		<>
			<Button text={t('common.strings.preview')} type='button' status='active' onClick={() => setShowModal(true)}/>
			{showModal && <Modal label={t('options_section.strings.wallet_apple_preview')} width={723} unmount={() => setShowModal(false)} style={{ display: 'flex' }}>
				<div style={{ margin: 'auto' }}>
					<Label>{t('options_section.strings.card_preview')}</Label>
					<StyledCard height={410} backgroundColor={backgroundColor}>
						<StyledRow>
							<Image style={{ width: '160px', height: '49px', ...!wideLogoImg && { background: 'rgba(255, 255, 255, 0.5)' } }} src={wideLogoImg}/>
							<div>
								<Label fontSize='9px' color={labelColor}>{t('loyalty_card_section.fields.card_number').toUpperCase()}</Label>
								<Label fontSize='16px' color={foregroundColor} fontWeight={300}>00000001</Label>
							</div>
						</StyledRow>
						<Divider height={15}/>
						<Label fontSize='22px' color={foregroundColor} fontWeight={300}>{t('loyalty_card_section.fields.card_name').toUpperCase()}</Label>
						<Divider height={80}/>
						<StyledRow>
							<div>
								<Label fontSize='9px' color={labelColor}>{t('loyalty_card_section.fields.balance').toUpperCase()}</Label>
								<Label fontSize='16px' color={foregroundColor} fontWeight={300}>{appData.mainCurrency} 0000.0</Label>
							</div>
							<div>
								<Label fontSize='9px' color={labelColor}>{formData.programName}</Label>
								<Label fontSize='16px' color={foregroundColor} fontWeight={300}>0</Label>
							</div>
						</StyledRow>
						<Divider height={50}/>
						<QRContainer>
							<QRCode/>
							<Label fontSize='12px' alignSelf='center' color={foregroundColor} fontWeight={300}>{t('options_section.strings.wallet_more_info')}</Label>
						</QRContainer>
					</StyledCard>
				</div>
				<div style={{ margin: 'auto' }}>
					<Label>{t('options_section.strings.cardinfo_preview')}</Label>
					<StyledCard height={410} backgroundColor={backgroundColor}>
						<StyledCardInfo>
							<div>
								<Label fontSize='10px' fontWeight={500}>QR-Code</Label>
								<Label fontSize='10px'>00000000-0000-0000-0000-000000000000</Label>
							</div>
							<Divider visible height={1}/>
							<div>
								<Label fontSize='10px' fontWeight={500}>{t('options_section.fields.vcard_description')}</Label>
								<Label fontSize='10px'>{accountIdLabel}</Label>
							</div>
							<Divider visible height={1}/>
							<div>
								<Label fontSize='10px' fontWeight={500}>{rewardsTierLabel}</Label>
								<Label fontSize='10px'>{rewardsTier}</Label>
							</div>
							<Divider visible height={1}/>
							<div>
								<Label fontSize='10px' fontWeight={500}>{secondaryRewardsTierLabel}</Label>
								<Label fontSize='10px'>{secondaryRewardsTier}</Label>
							</div>
							<Divider visible height={1}/>
							<div>
								<Label fontSize='10px' fontWeight={500}>{homepageUri?.description}</Label>
								<Label fontSize='10px'>{homepageUri?.link}</Label>
							</div>
							<Divider visible height={1}/>
							<div>
								<Label fontSize='10px' fontWeight={500}>{linkPhoneUri?.description}</Label>
								<Label fontSize='10px'>{linkPhoneUri?.link}</Label>
							</div>
							<div>
								<Label fontSize='10px' fontWeight={500}>{t('options_section.strings.wallet_orders_link')}</Label>
								<Label fontSize='10px'>{'https://shortlink.com/**********'}</Label>
							</div>
						</StyledCardInfo>
					</StyledCard>
				</div>
			</Modal>}
		</>
	)
}

export default AppleModalPreview